import { render, staticRenderFns } from "./icon-glosario.vue?vue&type=template&id=7d536e96&scoped=true&"
import script from "./icon-glosario.vue?vue&type=script&lang=js&"
export * from "./icon-glosario.vue?vue&type=script&lang=js&"
import style0 from "./icon-glosario.vue?vue&type=style&index=0&id=7d536e96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d536e96",
  null
  
)

export default component.exports